import React from 'react';
import Collapse, {Panel} from 'rc-collapse';
import moment from 'moment';

import {couponAnnuityType} from '../../helpers/data-constants';
import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_collapse.scss';
import './department-edit.scss';

const Coupon = ({coupon, isBase, extra, isAnnuity}) => {
    if (!coupon) {
        return null;
    }

    let things = false;
    let purity = false;
    let cars = false;

    let rows = coupon.rows && coupon.rows.map((row) => {
        const percentsMap = row.percentsMap || {};
        const purityMap = percentsMap.PURITY || {};
        const thingsMap = percentsMap.THINGS || {};
        const carsMap = percentsMap.CARS || {};

        let percents = {
            basePurity: purityMap.base ?? null,
            delayPurity: purityMap.delay ?? null,
            baseThings: thingsMap.base ?? null,
            delayThings: thingsMap.delay ?? null,
            baseCars: carsMap.base ?? null,
            delayCars: carsMap.delay ?? null,
        };

        things = things || (percents.baseThings !== null || percents.delayThings !== null);
        purity = purity || (percents.basePurity !== null || percents.delayPurity !== null);
        cars = cars || (percents.baseCars !== null || percents.delayCars !== null);

        let sum = `${row.startPrice ?? ''} — ${row.endPrice ?? ''}`;

        return {
            ...percents,
            purity: purity,
            things: things,
            cars: cars,
            sum: sum,
            id: row.id
        }
    });

    return (
        <Collapse className="" collapsible={"header"}>
            <Panel showArrow={!!rows && rows.length > 0}
                   header={(isBase ? 'Базовый' : coupon.name) + `${coupon.active ? '' : ' (неактивный)'}`}
                   headerClass={"block-datacollapse-header" + (coupon.active ? '' : ' error')}
                   className="block-datacollapse-container"
                   extra={<React.Fragment>
                       {isAnnuity && (
                           <span
                               className={`badge ${coupon.couponType.toLowerCase()}`}>{couponAnnuityType[coupon.couponType]}</span>
                       )}
                       <div
                           className={'coupon-info'}>
                           {` Срок микрозайма ${coupon.minDuration} - ${coupon.maxDuration}, действует `}
                           &nbsp;<span
                           className={moment().isBefore(coupon.startDate) ? 'error' : ''}>{' ' + moment(coupon.startDate).format('DD.MM.YYYY')}</span>
                           &nbsp;—&nbsp;
                           <span
                               className={moment().isAfter(coupon.endDate) ? 'error' : ''}>{' ' + moment(coupon.endDate).format('DD.MM.YYYY')}</span>
                       </div>
                       <div>{extra}</div>
                   </React.Fragment>}>
                {rows && rows.length > 0 && <table className="table hover">
                    <thead>
                    <tr>
                        <th scope="col">Сумма, руб.</th>
                        {purity && (<React.Fragment>
                            <th scope="col">Базовый д/м</th>
                            <th scope="col">Неустойка д/м</th>
                        </React.Fragment>)}
                        {things && (<React.Fragment>
                            <th scope="col">Базовый вещи</th>
                            <th scope="col">Неустойка вещи</th>
                        </React.Fragment>)}
                        {cars && (<React.Fragment>
                            <th scope="col">Базовый авто</th>
                            <th scope="col">Неустойка авто</th>
                        </React.Fragment>)}
                    </tr>
                    </thead>
                    <tbody>
                    {rows.map((row) => {
                        return (
                            <tr key={row.id}>
                                <th scope="row">
                                    <span className="caption">Сумма, руб.</span>
                                    <p>{row.sum}</p>
                                </th>
                                {purity && (<React.Fragment>
                                    <td>
                                        <span className="caption">Базовый д/м</span>
                                        <p>{row.basePurity}%</p>
                                    </td>
                                    <td>
                                        <span className="caption">Просрочка д/м</span>
                                        <p>{row.delayPurity}%</p>
                                    </td>
                                </React.Fragment>)}
                                {things && (<React.Fragment>
                                    <td>
                                        <span className="caption">Базовый вещи</span>
                                        <p>{row.baseThings}%</p>
                                    </td>
                                    <td>
                                        <span className="caption">Просрочка вещи</span>
                                        <p>{row.delayThings}%</p>
                                    </td>
                                </React.Fragment>)}
                                {cars && (<React.Fragment>
                                    <td>
                                        <span className="caption">Базовый авто</span>
                                        <p>{row.baseCars}%</p>
                                    </td>
                                    <td>
                                        <span className="caption">Просрочка авто</span>
                                        <p>{row.delayCars}%</p>
                                    </td>
                                </React.Fragment>)}
                            </tr>
                        )
                    })}
                    </tbody>
                </table>}
            </Panel>
        </Collapse>
    )
}

export default Coupon;
